import { supabase } from './supabaseClient';
import { MysterySponsorship } from '../types';

// A survey owner records a sponsorship for the global Community Mystery Box. It stays
// PENDING_PAYMENT until paid (KHQR/card — wired later) and confirmed. Returns the new id.
export const createMysterySponsorship = async (
  surveyId: string | null,
  rewardName: string,
  amount: number,
  currency: string = 'USD',
): Promise<{ id: string; status: string; amount: number; currency: string }> => {
  const { data, error } = await supabase.rpc('create_mystery_sponsorship', {
    p_survey_id: surveyId,
    p_reward_name: rewardName,
    p_amount: amount,
    p_currency: currency,
  });
  if (error) throw error;
  return data as any;
};

// The caller's own sponsorships (RLS-scoped). CTO sees all.
export const fetchMySponsorships = async (): Promise<MysterySponsorship[]> => {
  const { data: { user } } = await supabase.auth.getUser();
  if (!user) return [];
  const { data, error } = await supabase
    .from('mystery_sponsorships')
    .select('*')
    .eq('sponsor_id', user.id)
    .order('created_at', { ascending: false });
  if (error) throw error;
  return (data as MysterySponsorship[]) || [];
};

// Pending sponsorships awaiting payment confirmation (CTO settlement queue).
export const fetchPendingSponsorships = async (): Promise<MysterySponsorship[]> => {
  const { data, error } = await supabase
    .from('mystery_sponsorships')
    .select('*')
    .eq('status', 'PENDING_PAYMENT')
    .order('created_at', { ascending: false });
  if (error) throw error;
  return (data as MysterySponsorship[]) || [];
};

// Confirm payment and mint the prize into the community box (CTO-only until KHQR webhook).
export const confirmMysterySponsorship = async (id: string, paymentRef: string = 'MANUAL') => {
  const { data, error } = await supabase.rpc('confirm_mystery_sponsorship', {
    p_sponsorship_id: id,
    p_payment_ref: paymentRef,
  });
  if (error) throw error;
  return data as { ok: boolean; reason?: string; loot_item_id?: string };
};

export const cancelMysterySponsorship = async (id: string) => {
  const { data, error } = await supabase.rpc('cancel_mystery_sponsorship', { p_sponsorship_id: id });
  if (error) throw error;
  return data as { ok: boolean; reason?: string };
};
